import React from 'react';

  const LongInput = ({text, value, onChange, error, type = "text", identifier="default-input"}) => {
    return (
      <>
        <style>
        @import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
          {`
            .input-field {
              display: flex;
              width: 90%;
              height: 39px;
              padding-left: 20px;
              align-items: center;
              border-radius: 24px;
              border: 1px solid #6B3A8F;
              background: rgba(243, 243, 243, 0.10);
              backdrop-filter: blur(25px);
              cursor: pointer;
              position: relative;
              color: #E1E1E6;
              font-family: 'Poppins', sans-serif;
              font-size: 12px;
              font-style: normal;
              font-weight: 400;
              line-height: 120%;
            }
              
            .input-field::placeholder {
              background: linear-gradient(90deg, #9797FA 0%, #B849D6 100%);
              background-clip: text;
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }

            .error-text {
              color: #ff4d4f;
              font-size: 12px;
              margin-top: 4px;
              text-align: center;
              width: 100%;
            }
          `}
        </style>
        
        <input 
          className="input-field"
          type={type}
          placeholder={text}
          value={value}
          onChange={onChange}
          data-cy={identifier}
        />
        {error && <div className="error-text">{error}</div>}
      </>
    );
  }
  
export default LongInput;